import { Language } from '../i18n'
import { Scenario, ScenarioType } from '../state/interfaces'
import {
  chooseScenarioId,
  findScenarioById,
  getAllScenarios,
  findPreviousUsedScenarioIdBasedOnType,
  registerScenarioIdByType,
} from './registry'

export interface ScenarioBuilder {
  id: string | null
  isPreAssembled: boolean
  type: ScenarioType | null
  language: string | null
  initialInformation: Record<string, any>
  scenariosToAvoid: Array<string>
  withScenarioId: (scenarioId: string) => ScenarioBuilder
  withScenarioType: (scenarioType: ScenarioType) => ScenarioBuilder
  withLanguage: (scenarioLanguage: Language) => ScenarioBuilder
  withInitialInformation: (scenarioInitialInformation: Record<string, any>) => ScenarioBuilder
  build: () => Scenario
}

export const scenarioBuilder = (): ScenarioBuilder => ({
  type: null,
  id: null,
  language: null,
  initialInformation: {},
  isPreAssembled: false,
  scenariosToAvoid: [],

  withScenarioId(scenarioId: string) {
    this.id = scenarioId

    return this
  },

  withScenarioType(scenarioType: ScenarioType) {
    this.type = scenarioType

    return this
  },

  withLanguage(scenarioLanguage: Language) {
    this.language = scenarioLanguage

    return this
  },

  withInitialInformation(scenarioInitialInformation: Record<string, any>) {
    this.initialInformation = scenarioInitialInformation

    return this
  },

  build() {
    if (!this.type) {
      this.type = ScenarioType.MOBILE
    }

    if (!this.id) {
      const savedScenarioId = findPreviousUsedScenarioIdBasedOnType(this.type)

      if (savedScenarioId) {
        const foundScenario = findScenarioById(savedScenarioId)
        if (foundScenario) {
          if (savedScenarioId !== 'mobile-d') {
            this.id = savedScenarioId
          } else {
            this.scenariosToAvoid.push('mobile-d')
          }
        }
      }
    }

    if (!this.id) {
      const scenarioIdsToChooseFrom = getAllScenarios()
        .filter(
          (scenario) =>
            scenario.type === this.type && scenario.weight !== 0 && !this.scenariosToAvoid.includes(scenario.id),
        )
        .map((scenario) => scenario.id)
      this.id = chooseScenarioId(scenarioIdsToChooseFrom)
    }

    if (!this.language) {
      this.language = Language.en
    }

    const foundScenario = findScenarioById(this.id)

    if (!foundScenario) {
      throw new Error(`Could not find scenario with id ${this.id}`)
    }

    registerScenarioIdByType(this.type, this.id)

    return foundScenario
  },
})
